<template>
    <el-card>
        <!-- 搜索 -->
        <el-row class="trainVideo__search">
            <div class="item">
                <span>培训视频分类:</span>
                <el-input v-model="searchList.tagName" placeholder="请输入分类名称"></el-input>
            </div>
            <el-button type="primary" @click="querys(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                dialogVisibles = true
                dialogTypes = 0
            }">添加</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="trainVideoList">
                <el-table-column prop="id" label="ID" align="center">
                </el-table-column>
                <el-table-column prop="tagName" label="分类名称" align="center">
                </el-table-column>
                <el-table-column prop="language" label="语言" align="center">
                </el-table-column>
                <el-table-column prop="status" label="是否有效" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.status == 1 ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                </el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center">
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center">
                </el-table-column>
                <el-table-column width="200" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="update(scope.row)">编辑</el-button>
                        <el-button type="success" @click="delete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <el-dialog :visible.sync="dialogVisibles" :title="dialogTypes == 0 ? '培训视频分类配置添加' : '培训视频分类配置编辑'" width="30%">
            <el-form :model="upDateInfo" label-width="120px">

                <el-form-item label="培训视频分类">
                    <el-input v-model="upDateInfo.tagName" placeholder="请输入分类"></el-input>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="upDateInfo.language" placeholder="请选择">
                        <el-option v-for="(item, index) in langList" :key="index" :label="item.language" :value="item.langCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否有效">
                    <el-switch v-model="upDateInfo.status" :active-value="1" :inactive-value="0" active-text="是"
                        inactive-text="否"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="warning" @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="submit(upDateInfo, closeDialog, closeDialog)">{{ dialogTypes == 0 ? '添加' : '编辑' }}</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'

export default {
    components: {
        UploadSingleImg
    },
    data() {
        return {
            page: 1,
            pageSize: 30,
            total: 0,
            dialogVisibles: false,
            dialogTypes: 0,
            searchList: {
                tagName:null
            },
            upDateInfo: {
                tagName: null,
                language: null,
                status: null,
            },
            langList: [],
            tagTypeList: [],
            trainVideoList: []
        }
    },
    created() {
        this.querys(1)
        this.getLang()
    },
    methods: {
        closeDialog() {
            this.dialogVisibles = false
            this.upDateInfo = {
                tagName: null,
                language: null,
                status: null,
            }
        },
        guaranteedHandleCurrentChange(page) {
            this.querys(page)
        },
        //获取语言
        async getLang() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.langList,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.langList = res.data
            }
        },
        async querys(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_train_video_tag_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    page: this.page,
                },
                data: {
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                this.trainVideoList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async delete(id) {
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_train_video_tag_delete,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    id
                }
            })
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.$message.success('操作成功')
                this.querys()
            }
        },
        update(info) {
            this.dialogVisibles = true
            this.dialogTypes = 1
            this.upDateInfo = info
        },
        async submit(info, fun) {
            const data = JSON.parse(JSON.stringify(info))
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_train_video_tag_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                fun && fun()
                this.$message.success('操作成功')
                this.querys(1)
            }
        }
    }
}
</script>
<style scoped lang="scss">
.trainVideo {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
            width: max-content;
        }

    }
}
</style>